import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

//  Services
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    selector: 'standard-component',
    templateUrl: './standard.component.html'
})

export class StandardComponent {

    title: string = "Review Portal";
    session: any = {};
    activeRoute: string;

    constructor(
        private router: Router, 
        private authService: AuthenticationService) { 

    }

    ngOnInit() {

        this.activeRoute = this.router.url;
        this.session = this.authService.retrieveSession();

        this.authService.Session$.subscribe(session => {
            this.session = session;
            this.activeRoute = this.router.url;
        });
    }

    signOut() {
        this.authService.clearSession();
        this.router.navigate(['']);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/standard/standard.component.ts